import { createNamedContext } from '@trinity/chat-components';
import type { Transcript } from './interfaces';

type SidebarPositionsContextValue =
  [Transcript.Sidebar.PositionMap, Transcript.Sidebar.SetPosition];

export const TranscriptSidebarPositionsContext = createNamedContext<SidebarPositionsContextValue>(undefined, 'TranscriptSidebarPositionsContext');